import { Card } from "primereact/card";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import Divider from "../../../components/menu/Divider";
 
export default function IndicadorPJ({ indicadores }: { indicadores: any }) {
  const { t } = useTranslation();
  const headerCard = (descricao: string) => {
    return (
      <div
        className="flex-score align-items-center"
        style={{ padding: "1.5rem" }}
      >
        <div
          className="flex-score justify-content-center align-items-center p-2 border-round"
          style={{ backgroundColor: "#183462" }}
        >
          <i className="pi pi-chart-line" style={{ color: "#FFF" }}></i>
        </div>
        <span className="text-xl ml-2 font-semibold">{descricao}</span>
      </div>
    );
  };
  return (
    <Panel header={t("indicadoresNegocios")} className="content-width panel-renda">
      <div className="grid-indicador flex-wrap gap-3">
      {indicadores.map((indicador: any) => {
        return (
          
            <Card className="col-12 lg:col-indicador-3 p-4">
             
                <div className="text-blue-600 font-medium my-2">
                  {indicador.descricao}
                </div>
                <div className="border-top-3 border-blue-600"></div>
                <div className="text-900 font-medium text-xl line-height-3 mb-4">{indicador.faixa}</div>
                <Divider></Divider>
                <div style={{marginBottom: '-1rem', paddingBottom: '-1rem'}} className="font-medium my-2">Conceito</div>
                <div className="font-sm text-700 line-height-3">{indicador.conceito}</div>
              
           </Card>
 
        );
      })}
       </div>
    </Panel>
  );
}